// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmailCommunicationDestination
 */
export interface IEmailCommunicationDestination {
    /**
     * 
     * @type {string}
     * @memberof IEmailCommunicationDestination
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailCommunicationDestination
     */
    sent_to?: string;
}

/**
 * Check if a given object implements the IEmailCommunicationDestination interface.
 */
export function instanceOfIEmailCommunicationDestination(value: object): value is IEmailCommunicationDestination {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IEmailCommunicationDestinationFromJSON(json: any): IEmailCommunicationDestination {
    return IEmailCommunicationDestinationFromJSONTyped(json, false);
}

export function IEmailCommunicationDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmailCommunicationDestination {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'sent_to': json['sent_to'] == null ? undefined : json['sent_to'],
    };
}

export function IEmailCommunicationDestinationToJSON(json: any): IEmailCommunicationDestination {
    return IEmailCommunicationDestinationToJSONTyped(json, false);
}

export function IEmailCommunicationDestinationToJSONTyped(value?: IEmailCommunicationDestination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'sent_to': value['sent_to'],
    };
}

